var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListTopic = function SvgListTopic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 25",
    enableBackground: "new 0 0 20 25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fill",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,2 C2.51848522,2 2,2.54002055 2,3 L2,22 C2,22.4542863 2.52490946,23 3,23 L17,23 C17.4815148,23 18,22.4599794 18,22 L18,8 L18.2243436,9.2979399 L9.78987599,1.51525596 L11,2 L3,2 Z M12,0 L20,8 L20,22.2185358 C20,23.5897343 18.9590987,25 17.4968606,25 L2.63142135,25 C1.17812747,25 0,23.8849777 0,22.5172255 L0,2.65518826 C0,1.28398979 1.63414625,0 3.09638437,0 L12,0 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,10 L18.7547866,10 L17.9005877,8.0862069 L13,8 C12,8 12,7 12,7 L12,2 L10,0.461580985 L10,1.50101801 L10,8 C10,9.17713036 10.736216,10 12,10 L18,10 L19,10 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 12,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 12,
    height: 2,
    rx: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListTopic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-topic.56db69e6.svg";
export { ForwardRef as ReactComponent };